import { render, staticRenderFns } from "./FormSidebar.vue?vue&type=template&id=772036bf"
import script from "./FormSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSidebar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports